import React from "react";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
    return (
        <footer className="bg-white text-gray-900 dark:bg-gray-900 dark:text-white mt-auto border-t border-gray-200 dark:border-gray-800 transition-colors">
            <div className="max-w-[1400px] mx-auto px-6 py-16">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
                    {/* Brand Section */}
                    <div className="space-y-4">
                        <div className="flex items-center gap-2">
                            <span className="text-3xl">🍽️</span>
                            <span className="text-2xl font-bold tracking-tight">
                                Easy<span className="text-orange-500">Eats</span>
                            </span>
                        </div>
                        <p className="text-gray-500 dark:text-gray-400 text-sm leading-relaxed max-w-xs">
                            Discover the best food & drinks in your city. Delivered with love and care, straight to your doorstep.
                        </p>
                        {/* Social Links */}
                        <div className="flex gap-4 pt-2">
                            {['facebook', 'twitter', 'instagram', 'linkedin'].map((social) => (
                                <a
                                    key={social}
                                    href="#"
                                    className="w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-800 hover:bg-orange-500 group flex items-center justify-center transition-all duration-300 hover:-translate-y-1"
                                >
                                    <i className={`fa-brands fa-${social === 'facebook' ? 'facebook-f' : social} text-gray-600 dark:text-gray-300 group-hover:text-white transition-colors`}></i>
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Link (Simplified) */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-gray-900 dark:text-white border-b-2 border-orange-500 inline-block pb-1">Quick Links</h3>
                        <ul className="space-y-3">
                            <li>
                                <Link to="/" className="text-gray-600 dark:text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-2 group">
                                    <i className="fa-solid fa-chevron-right text-xs opacity-0 group-hover:opacity-100 transition-opacity"></i>
                                    Home
                                </Link>
                            </li>
                            <li>
                                <Link to="/cart" className="text-gray-600 dark:text-gray-400 hover:text-orange-500 transition-colors flex items-center gap-2 group">
                                    <i className="fa-solid fa-chevron-right text-xs opacity-0 group-hover:opacity-100 transition-opacity"></i>
                                    Cart
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-gray-900 dark:text-white border-b-2 border-orange-500 inline-block pb-1">Get in Touch</h3>
                        <ul className="space-y-4">
                            <li className="flex items-start gap-3 text-gray-600 dark:text-gray-400 group cursor-pointer hover:text-orange-500 dark:hover:text-white transition-colors">
                                <div className="mt-1 w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors">
                                    <i className="fa-solid fa-location-dot text-sm group-hover:text-white transition-colors"></i>
                                </div>
                                <span className="text-sm leading-relaxed">
                                    123 Food Street, Tasty Town,<br />
                                    Flavor District, India 456789
                                </span>
                            </li>
                            <li className="flex items-center gap-3 text-gray-600 dark:text-gray-400 group cursor-pointer hover:text-orange-500 dark:hover:text-white transition-colors">
                                <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors">
                                    <i className="fa-solid fa-envelope text-sm group-hover:text-white transition-colors"></i>
                                </div>
                                <span className="text-sm">support@easyeats.com</span>
                            </li>
                            <li className="flex items-center gap-3 text-gray-600 dark:text-gray-400 group cursor-pointer hover:text-orange-500 dark:hover:text-white transition-colors">
                                <div className="w-8 h-8 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center flex-shrink-0 group-hover:bg-orange-500 transition-colors">
                                    <i className="fa-solid fa-phone text-sm group-hover:text-white transition-colors"></i>
                                </div>
                                <span className="text-sm">+91 1800-123-4567</span>
                            </li>
                        </ul>
                    </div>

                    {/* Newsletter */}
                    <div>
                        <h3 className="text-lg font-semibold mb-6 text-gray-900 dark:text-white border-b-2 border-orange-500 inline-block pb-1">Newsletter</h3>
                        <p className="text-gray-500 dark:text-gray-400 text-sm mb-4">Subscribe for offers and updates.</p>
                        <form className="space-y-2" onSubmit={(e) => e.preventDefault()}>
                            <input
                                type="email"
                                placeholder="Email Address"
                                className="w-full px-4 py-3 bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg text-gray-900 dark:text-white text-sm focus:outline-none focus:border-orange-500 transition-colors"
                            />
                            <button className="w-full py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg text-sm transition-colors shadow-lg hover:shadow-orange-500/20">
                                Subscribe
                            </button>
                        </form>
                    </div>
                </div>

                {/* Copyright Bar */}
                <div className="border-t border-gray-200 dark:border-gray-800 mt-16 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 transition-colors">
                    <p className="text-gray-500 text-sm text-center md:text-left">
                        © {new Date().getFullYear()} EasyEats. Designed with <i className="fa-solid fa-heart text-red-500 mx-1 animate-pulse"></i> by Shivam.
                    </p>
                    <div className="flex gap-6 text-sm text-gray-500">
                        <a href="#" className="hover:text-orange-500 transition-colors">Privacy</a>
                        <a href="#" className="hover:text-orange-500 transition-colors">Terms</a>
                        <a href="#" className="hover:text-orange-500 transition-colors">Sitemap</a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
